'use client'

import { PropsWithChildren } from 'react'

// import { WagmiProvider } from 'wagmi'
import { WagmiProvider } from '@privy-io/wagmi'

import { config } from '@/config/wagmiConfig'

// import { config } from '@/libs/wagmiClient'
import { QueryProvider } from './QueryProvider'

export type ProviderProps = PropsWithChildren
export const Web3Provider: React.FC<ProviderProps> = ({ children }) => {
  return (
    <QueryProvider>
      <WagmiProvider config={config}>{children}</WagmiProvider>
    </QueryProvider>
  )
}
